import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { CountryChangeStatusEnum } from '../models/status';
import { CountryChangerService } from './country-changer.service';

export const countryChangeGuard: CanActivateFn = () => {
  const router = inject(Router);
  const countryChangerService = inject(CountryChangerService);
  const redirect = router.createUrlTree(['profile']);

  return countryChangerService.getStatus().pipe(
    map(({ status }) => status !== CountryChangeStatusEnum.new || redirect),
    catchError(() => of(redirect)),
  );
}
